import { RolesPermissionsModule } from './../roles-permissions-store/roles-permissions.module';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthStoreEffects } from './auth-store.effects';
import { authReducer, AUTH_FEATURE_KEY } from './auth-store.reducer';


@NgModule({
    imports: [
        StoreModule.forFeature(AUTH_FEATURE_KEY, authReducer),
        EffectsModule.forFeature([AuthStoreEffects]),
        RolesPermissionsModule
    ]
})
export class AuthStoreModule { }
